export default __webpack_public_path__ + "static/media/mysql-logo.38d6d720.svg";